import { SET_SITE_CONFIG_PROPERTIES } from '../actions/types';

export default function siteConfigProperties(state = {}, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_SITE_CONFIG_PROPERTIES:
				return action.payload;

			// no default
		}
	}

	return state;
}
